<template>
  <b-alert show class="alert-info border-none pl-2 pt-1 pb-1">
    <div class="content-alert-info">
      <div>
        <img src="@/assets/images/icons/information-line.svg" />
      </div>
      <b>
        {{
          record
            ? "Recuerda que puedes editar el GES en la sección de Identificación y en la sección de Agregar Empleados."
            : "Recuerda que puedes guardar el GES sin empleados o agregar los empleados antes de dar clic en Guardar GES"
        }}
      </b>
    </div>
  </b-alert>
</template>
<script>
export default {
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style lang="scss">
.alert-info {
  background: #e6f7ff !important;
  border-radius: 4px !important;
  border: 1px solid #0075ff !important;
  margin-bottom: 25px !important;
}
.content-alert-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #004bd1;
}
</style>
